import { render, staticRenderFns } from "./agent-home.vue?vue&type=template&id=552f2ddf&scoped=true"
import script from "./agent-home.vue?vue&type=script&lang=js"
export * from "./agent-home.vue?vue&type=script&lang=js"
import style0 from "./agent-home.vue?vue&type=style&index=0&id=552f2ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f2ddf",
  null
  
)

export default component.exports